/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {RestResponse} from '../model';
import {ApiHeaders} from './headers';
import {AppFileData} from '../model/app-file-data';
import { Observable } from 'rxjs';

@Injectable()
export class ExportProvider {

  constructor(
    private http: HttpClient
  ) {}

  requestExport(id: string, templateId: string, file: AppFileData): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/export?template=${templateId}`, file, ApiHeaders.getOptions());
  }

  setClientState(id: string, hid: string, state: string): Observable<RestResponse> {
    return this.http
      .put<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/export/${hid}/set?state=${state}`, null, ApiHeaders.getOptions());
  }

  getHistory(id: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/export/history`, ApiHeaders.getOptions());
  }
}
